module.exports = __webpack_public_path__ + "static/img/no-data.8287a54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/no-data.png
// module id = jAGn
// module chunks = 212